import {Injectable, Signal} from '@angular/core';
import {SeFeDomainEnvironmentService} from 'se-fe-domain-environment';
import {Store} from '@ngrx/store';
import {toSignal} from '@angular/core/rxjs-interop';
import {selectBaseUriProxy} from '../../../common/context-data/context-data.selectors';

@Injectable({providedIn: 'root'})
export class CommerceDomainService {
  baseUriProxy: Signal<string | undefined>;
  seApiUrl: string;

  constructor(
    private seFeDomainEnvironmentService: SeFeDomainEnvironmentService,
    private store: Store,
  ) {
    this.baseUriProxy = toSignal(this.store.select(selectBaseUriProxy));
    this.seApiUrl = this.seFeDomainEnvironmentService
      .getUrl('seApi')
      .slice(0, -1);
  }

  /**
   * Constructs a full URL for SE API endpoints. The path should not start with a slash.
   * @param path
   */
  getUrl(path: string): string {
    if (this.baseUriProxy()) {
      return `${this.baseUriProxy()}/${path}`;
    } else {
      return `${this.seApiUrl}/${path}`;
    }
  }
}
